// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jW2Y","colMin":"styles_colMin__3_dtA"};